import { makeAutoObservable, runInAction } from 'mobx';

class ChatInputStore {
  // 必填状态
  requiredFields = {
    classification: ['北京', '本科批'],
    grade: '',
    optional: [],
    // applicationBatch: '',
    volunteer: '',
    maxCount: 3,
  };

  // 选填状态
  optionalFields = {
    preferredRegions: [],
    preferredMajor: [],
    graduationIntention: '',
    province: '',
    //状态保存字段
    classification: [],
    optional: [],
    // applicationBatch: '',
    volunteer: '',
    preferredRegions1: [],
    preferredMajor1: [],
    graduationIntention1: '',
    province1: '',
  };
  warningActive=false

  setWarningActive(newFields){
    this.warningActive=newFields
  }

  constructor() {
    makeAutoObservable(this);
  }
//  定义一个状态控制
  kaiguanzhuangti=true

  // 修改必填状态
  setRequiredFields(newFields) {
    runInAction(() => {
      // 合并新字段到现有的必填字段
      this.requiredFields = { ...this.requiredFields, ...newFields };
    });
  }
  // 修改选填状态
  setOptionalFields(newFields) {
    runInAction(() => {
      this.optionalFields = { ...this.optionalFields, ...newFields };
    });
  }

  get prompt() {
    // 过滤掉不需要的值
    const filteredRegions = this.optionalFields.preferredRegions?.filter(
      region => !["一线城市", "新一线城市", "省份"].includes(region)
    );
  
    // 拼接偏好城市字符串
    const preferredRegionsStr = filteredRegions?.length > 0 
      ? `，我想在${filteredRegions?.join('、')}上大学` 
      : ''; // 如果过滤后的 preferredRegions 有值，则拼接字符串，否则为空
  
    // 拼接偏好专业字符串
    const lastValues = this.optionalFields.preferredMajor1?.map(item => item[item.length-1]);    
    const preferredMajorStr = lastValues?.length > 0 
      ? `，想学${lastValues?.join('、')}` 
      : ''; // 如果 preferredMajor 有值，则拼接字符串，否则为空
    // 拼接未来选择字符串
  const graduationIntentionStr = this.optionalFields.graduationIntention?.length > 0 
  ? `，未来选择${this.optionalFields.graduationIntention?.join('、')}` 
  : ''; // 如果 graduationIntention 有值，则拼接字符串，否则为空
  
    return `我是${this.requiredFields.classification[0]}的考生，考了${this.requiredFields.grade}分，选科${this.requiredFields.optional.join('、')}，志愿偏好是${this.requiredFields.volunteer}${preferredRegionsStr}${preferredMajorStr}${graduationIntentionStr}，请为我推荐学校和专业，生成志愿表`;
  }

  get agentId() {
    return 'edd495e32d774844b9bf9b0dd02d2bac'; // 高考选科
  }

  getFields() {
    return {
      // 报考省份
      province: this.requiredFields.classification[0],

      // 报考批次
      pici: this.requiredFields.classification[1],

      // 学科分类
      classify: this.optionalFields.province,
      // 分数
      score: this.requiredFields.grade,
      // 选科
      subjects: this.requiredFields.optional,

      // 再选科目
      bak_subjects: [],
      priority: '学校优先', // 学校优先、专业优先
      graduation: this.optionalFields.graduationIntention,

      // 偏好城市
      preferred_city: this.optionalFields.preferredRegions,

      // 偏好专业
      major: this.optionalFields.preferredMajor,
      gender: '',
      city_rank: '',
    };
  }
  // 清空必填状态清空部数据
  clearPartialData() {
    this.requiredFields = {
      ...this.requiredFields, // 保留其他字段的值
      grade: '',
      optional: [],
      // applicationBatch: '',
      volunteer: '',
      maxCount: 3,
    };
  }
  //清空回填数据
  clearDackfillData() {
    this.optionalFields = {
      ...this.optionalFields, // 保留其他字段的值
      optional: [],
      // applicationBatch: '',
      volunteer: '',
    };
  }

  // 清空必填状态
  clearRequiredFields() {
    this.requiredFields = {
      classification: ['北京', '本科批'],
      grade: '',
      optional: [],
      // applicationBatch: '',
      volunteer: '',
      maxCount: 3,
    };
  }

  // 清空选填状态
  clearOptionalFields() {
    this.optionalFields = {
      preferredRegions: [],
      preferredMajor: [],
      graduationIntention: '',
      preferredRegions: [],
      preferredMajor: [],
      graduationIntention: '',
      province: '',
      //状态保存字段
      optional: [],
      // applicationBatch: '',
      volunteer: '',
      preferredRegions1: [],
      preferredMajor1: [],
      graduationIntention1: '',
      province1: '',
    };
  }
  // 清空选填状态
  clearZtkaiguan() {
    this.kaiguanzhuangti = false
  }
  //清空偏好专业
  clearPreferredMajor() {
    this.optionalFields = {
      ...this.optionalFields, // 保留其他字段的值
      preferredMajor: [], // 清空 preferredMajor
      preferredMajor1: [], // 清空 preferredMajor1
    };
  }

  // 检查所有必填字段是否有效
  isAllFieldsValid() {
    return Object.entries(this.requiredFields).every(([key, value]) => {
      if (key === 'optional') {
        return value.length === this.requiredFields.maxCount;
      }
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== '';
    });
  }
}

const GaokaoxkStore = new ChatInputStore();
export default GaokaoxkStore;
